import React from 'react';
import Dashboard from '../../components/provider/dashboard'; // Sidebar
import Header from '../../components/provider/header'; // Header
import NewJobCreation from '../../components/provider/new_job_creation'; // Create New Job component
import JobList from '../../components/provider/JobList'; // Job list component
import NumberCard from '../../components/provider/card'; // Statistics cards component
import '../../styles/HomePage.css'; // Your CSS for this page

const HomePage = () => {
  return (
    <div className="home-page">
      <Dashboard /> {/* Sidebar */}
      <div className="main-content">
        <Header /> {/* Top Header */}
        
        {/* Main job creation and statistics section */}
        <div className="main-section">
          <NewJobCreation /> {/* Create New Job component */}
          
          <div className="job-stats">
            <JobList /> {/* Job list section */}
            
            {/* Stats Cards */}
            <div className="stats-cards">
              <NumberCard title="Applied" value="27" isPositive={true} />
              <NumberCard title="Jobs Posted" value="4" isPositive={true} />
              <NumberCard title="Assigned" value="3" isPositive={true} />
              <NumberCard title="Total Jobs" value="40" isPositive={true} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
